import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation('home');

  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylish%20overhead%20flat%20lay%20of%20premium%20fashion%20items%20including%20sneakers%20a%20leather%20tote%20sunglasses%20and%20a%20watch%20artfully%20arranged%20on%20a%20warm%20terracotta%20linen%20backdrop%20with%20soft%20morning%20side%20light%20casting%20long%20gentle%20shadows%2C%20editorial%20ecommerce%20hero%20photography%20in%20rich%20earth%20tones&width=1600&height=1000&seq=hero-bg-2026-01&orientation=landscape&nocache=true"
          alt="AllChinaBuy Spreadsheet product showcase"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      <div className="relative z-10 container-main w-full py-24 md:py-32">
        <div className="max-w-2xl">
          {/* Tag */}
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 text-accent-200 text-xs font-medium mb-6">
            <i className="ri-sparkling-line" />
            {t('common.independent')}
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 text-balance">
            {t('hero.title')}
          </h1>

          <p className="text-lg md:text-xl text-white/90 font-medium mb-4">
            {t('hero.subtitle')}
          </p>

          <p className="text-sm md:text-base text-white/75 leading-relaxed mb-8 max-w-xl">
            {t('hero.description')}
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3 mb-6">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-white font-medium text-sm whitespace-nowrap transition-all hover:bg-primary-600 hover:scale-[1.02] active:scale-[0.98]"
            >
              {t('hero.cta_primary')}
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#guides"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-white/10 backdrop-blur-sm text-white font-medium text-sm whitespace-nowrap border border-white/20 transition-all hover:bg-white/20"
            >
              {t('hero.cta_secondary')}
              <i className="ri-book-open-line" />
            </a>
          </div>

          {/* Secondary CTA buttons to main site */}
          <div className="flex flex-col sm:flex-row gap-3 mb-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-white/15 backdrop-blur-sm text-white font-medium text-xs whitespace-nowrap border border-white/25 transition-all hover:bg-white/25"
            >
              <i className="ri-external-link-line" />
              {t('cta.main_button')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-accent-500/30 backdrop-blur-sm text-white font-medium text-xs whitespace-nowrap border border-accent-400/40 transition-all hover:bg-accent-500/40"
            >
              <i className="ri-shopping-bag-line" />
              {t('cta.buy_now')}
            </a>
          </div>

          {/* Trust badge */}
          <p className="text-xs text-white/60 flex items-center gap-2">
            <i className="ri-shield-check-line text-accent-400" />
            {t('hero.trust_badge')}
          </p>
        </div>
      </div>
    </section>
  );
}